import type { VoidFunctionComponent } from 'react';

import { BUTTON_TYPE } from '../../../../generic/Button/button-constants';
import NavigationButton from '../../../../generic/Button/NavigationButton';
import Icon from '../../../../generic/Icon/Icon';
import { icons } from '../../../../generic/Icon/icons';

import styles from './CodeMirrorExpired.module.less';

type RetentionMetadataDateProps = {
  label: string;
  date: Date;
};

const RetentionMetadataDate: VoidFunctionComponent<RetentionMetadataDateProps> = ({ label, date }) => {
  return (
    <span className={styles.metadataDate}>
      <span className={styles.metadataDateLabel}>{label}</span>
      <span className={styles.metadataDateValue}>{date.toLocaleDateString()}</span>
    </span>
  );
};

type Props = {
  detectedAt: Date;
  expiresAt: Date;
};

/**
 * Shown when a user's source code retention period has ended.
 */
const CodeMirrorExpired: VoidFunctionComponent<Props> = ({ detectedAt, expiresAt }) => {
  return (
    <div className={styles.layout}>
      <div className={styles.content}>
        <div className={styles.icon}><Icon icon={icons.hourglass} size="fa-3x" /></div>
        <div className={styles.heading}>Code unavailable</div>
        <div className={styles.description}>
          This first-party matching code was automatically removed per your source code retention settings.
        </div>
        <div className={styles.metadata}>
          <RetentionMetadataDate label="DETECTED" date={detectedAt} />
          &middot;
          <RetentionMetadataDate label="EXPIRED" date={expiresAt} />
        </div>
        <div className={styles.configureRetention}>
          <NavigationButton to="/account/settings/organization" type={BUTTON_TYPE.SECONDARY}>Configure Retention</NavigationButton>
        </div>
      </div>
    </div>
  );
};

export default CodeMirrorExpired;
